import { useMap } from '../..';
import { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { PluginMapPositions } from 'rwl-shared/dist/models/plugin/Plugin';

interface MapControlProps {
    position: keyof typeof PluginMapPositions;
    style?: CSSProperties;
    children: ReactNode;
}

export const MapControl = ({ position, style, children }: MapControlProps) => {
    const { map } = useMap();
    const root = useRef(document.createElement('div'));
    root.current.setAttribute('id', 'rwl-map-controls');
    if (style) {
        Object.assign(root.current.style, style);
    }

    useEffect(() => {
        if (!map) {
            return;
        }

        map.controls[PluginMapPositions[position]].push(root.current);

        return () => {
            const controls =
                map.controls[PluginMapPositions[position]].getArray();
            const index = controls.indexOf(root.current);
            if (index > -1) {
                map.controls[PluginMapPositions[position]].removeAt(index);
            }
        };
    }, [map]);

    return createPortal(children, root.current);
};
